import { render, staticRenderFns } from "./MonitorPriceAdjustModal.vue?vue&type=template&id=6297a43e&scoped=true"
import script from "./MonitorPriceAdjustModal.vue?vue&type=script&lang=js"
export * from "./MonitorPriceAdjustModal.vue?vue&type=script&lang=js"
import style0 from "./MonitorPriceAdjustModal.vue?vue&type=style&index=0&id=6297a43e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6297a43e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\tx_projects\\plat-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6297a43e')) {
      api.createRecord('6297a43e', component.options)
    } else {
      api.reload('6297a43e', component.options)
    }
    module.hot.accept("./MonitorPriceAdjustModal.vue?vue&type=template&id=6297a43e&scoped=true", function () {
      api.rerender('6297a43e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/priceSetting/priceMonitoring/monitoringScreen/specificProduct/MonitorPriceAdjustModal.vue"
export default component.exports